import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
  NoItemsLeftInTable,
  handleDateSetUp,
} from "../../../../../helpers/helpers";
import Pagination from "../../../../commanPage/pagination/Pagination";
import TableLoader from "../../../../loader/TableLoader";

function EmdPaidTables({ paidEmdDetails, loading }) {
  const numberOfRow = 20;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <>
      {loading ? (
        <div className="valign-wrapper justify-center cover white">
          <TableLoader
            headerData={["Organization Name", "Amount", "Date"]}
            height={"170px"}
          />
        </div>
      ) : (
        <div className="table-container-style">
          <table
            className={`responsive-table centered ${
              isTablet ? "auction_table table-style" : "custom-table-style"
            } `}
          >
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {paidEmdDetails
                ?.slice(currentPage, currentPage + numberOfRow)
                ?.map((items, index) => (
                  <tr key={items?._id}>
                    <td>{index + 1}</td>
                    <td>{handleDateSetUp(items?.date)}</td>
                    <td>{items?.amount}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {paidEmdDetails?.length === 0 && <NoItemsLeftInTable />}
        </div>
      )}
      {paidEmdDetails?.length > numberOfRow - 5 && (
        <Pagination
          Data={paidEmdDetails}
          totalNumberRow={numberOfRow}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
}

export default EmdPaidTables;
